import { render, staticRenderFns } from "./Reservation.vue?vue&type=template&id=5b627e68&scoped=true&"
import script from "./Reservation.vue?vue&type=script&lang=ts&"
export * from "./Reservation.vue?vue&type=script&lang=ts&"
import style0 from "./Reservation.vue?vue&type=style&index=0&id=5b627e68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b627e68",
  null
  
)

component.options.__file = "Reservation.vue"
export default component.exports